const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#f2f2f2] to-[#f2f2f2] border-t border-gray-300 text-gray-400 text-[13px] p-4 text-center mt-auto">
      © 2025 Medusa Payments - Todos os direitos reservados.
    </footer>
  );
};

export default Footer;
